module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1f_D.6dd5b6c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-1f_D.svg
// module id = 514
// module chunks = 0